import React from 'react'
import { graphql } from 'gatsby'
import Team from '@components/Team'
import PropTypes from 'prop-types'

import classnames from 'classnames/bind'
import styles from './TeamContainer.module.scss'

const cx = classnames.bind(styles)

const TeamContainer = ({ header, subHeader, members, anchor, className, logos }) => (
  <div className={cx('container', className, 'grid', 'tablet-grid')} id={anchor}>
    <Team
      className={cx('col-l', 'col-l-8', 'col-l-o-2', 'team')}
      title={header}
      subHeader={subHeader}
      list={members}
      logos={logos}
    ></Team>
  </div>
)

export const query = graphql`
  fragment TeamDataFragment on ContentfulHomeTeam {
    anchor {
      url
    }
    title: header
    subHeader {
      subHeader
    }
    members {
      image {
        description
        file {
          url
        }
      }
      name
      title
      company
      education {
        education
      }
      fullTitle
      experience {
        experience
      }
      displaySection
    }
  }
`

TeamContainer.propTypes = {
  anchor: PropTypes.string,
  className: PropTypes.string,
  header: PropTypes.string.isRequired,
  subHeader: PropTypes.string.isRequired,
  members: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        description: PropTypes.string,
        url: PropTypes.string,
      }),
      name: PropTypes.string,
      title: PropTypes.string,
      company: PropTypes.string,
      experience: PropTypes.string,
      education: PropTypes.string,
      fullTitle: PropTypes.string,
      displaySection: PropTypes.string,
    })
  ),
}

export default TeamContainer
